<template>
  <section class="container">
    <TimeLine
      :timeline="timeline"
    />
    <Live01 :month="month"/>
    <Live02 :month="month"/>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import TimeLine from '@/components/molecules/202006/TimeLine.vue'
import Live01 from '@/components/organisms/Live01.vue'
import Live02 from '@/components/organisms/Live02.vue'

export default {
  props: {
    month: {
      type: String,
      required: true
    }
  },
  components: {
    TimeLine,
    Live01,
    Live02
  },
  data: () => ({
    timeline: [
      'すべて',
      '10:30',
      '11:00',
      '11:30',
      '12:00',
      '12:30',
      '13:00',
      '13:30',
      '14:00',
      '14:30',
      '15:00'
    ]
  }),
  mounted () {
    this.resetLive()
  },
  methods: {
    ...mapActions([
      'resetLiveProgram'
    ]),
    async resetLive () {
      await this.resetLiveProgram()
    }
  }
}
</script>

<style lang="sass" scoped>
section
  background-color: $lightpink
  padding-top: 15px
  margin-top: 25px
  .live /deep/
    .description
      margin-top: 5px
      p
        line-height: 1.6
        font-size: 1.2rem
    .live-programs
      display: flex
      justify-content: space-between
      flex-wrap: wrap
      .program-wrapper
        width: calc(50% - 10px)
</style>
